import { create } from 'zustand';

export interface SyncStatus {
  online: boolean;
  syncing: boolean;
  pending: number;
  failed: number;
  quarantined: number;
  rejected: number;
  lastSyncAt: number | null;
  lastError: string | null;
  snapshot: { running: boolean; done: number; total: number } | null;
  needsUpgrade: boolean;
  /** first-ever sync on this device has not finished: show a loading state instead of an empty shop */
  initial: boolean;
}

export const useSync = create<SyncStatus>(() => ({
  online: typeof navigator === 'undefined' ? true : navigator.onLine,
  syncing: false, pending: 0, failed: 0, quarantined: 0, rejected: 0, lastSyncAt: null, lastError: null, snapshot: null, needsUpgrade: false, initial: false,
}));
export const setSync = (p: Partial<SyncStatus>): void => useSync.setState(p);
